"use client"

// https://next-intl.dev/docs/environments/error-files
// capture non localized errors

// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
import Error from "next/error"

export default function NotFound() {
  return (
    <html lang="en">
      <body>
        <Error statusCode={404} />
      </body>
    </html>
  )
}
